import { render } from "./BusinessAccountingForTo.vue?vue&type=template&id=489bc54e&scoped=true&ts=true"
import script from "./BusinessAccountingForTo.vue?vue&type=script&lang=ts"
export * from "./BusinessAccountingForTo.vue?vue&type=script&lang=ts"

import "./BusinessAccountingForTo.vue?vue&type=style&index=0&id=489bc54e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489bc54e"]])

export default __exports__